<template>
  <div class="group-comment-sidebar">
    <b-sidebar position="absolute"
               :right="true"
               :fullheight="true"
               :overlay="false"
               :open="open"
               @close="cancel">
      <div class="calendar-entry-form" v-if="rate">
        
        <div class="calendar-entry-sidebar-field">
          <div class="sidebar-field-header">
            {{ headerText }}
          </div>
        </div>
        
        <div class="sidebar-body">
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Kørsel HV.</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.drivingRateWeekday" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Kørsel SH.</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.drivingRateHoliday" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Kørsel før 07:15 HV.</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.hourRateWeekdayDrivingBefore" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Kørsel før 07:15 SH.</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.hourRateWeekendDrivingBefore" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Time RTA HV.</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.hourRateWeekday" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Time RTA SH.</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.hourRateHoliday" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Time ATK HV.</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.hourRateWeekdayAtk" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Time ATK SH.</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.hourRateHolidayAtk" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Time barsel</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.hourRateWeekdayMaternity" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Pensions rate %.</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.pensionPercentage" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Anciennitet</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.seniorityRate" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Timer pr. session</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.tariff" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Vask af arbejdstøj</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.washingCloth" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
          <div class="calendar-entry-sidebar-field">
            <div class="sidebar-field-label">Timer pr. session</div>
            <div class="sidebar-field-input">
              <b-numberinput v-model="rate.hoursPrSession" :controls="false" @input="modelUpdated" step="0.01" />
            </div>
          </div>
        </div>
        <div class="sidebar-footer">
          <div class="sidebar-footer-controls">
            <b-button @click="update" class="is-blue" :loading="loading">Opdater</b-button>
            <b-button @click="cancel" class="is-text">Annuller</b-button>
          </div>
          <div class="sidebar-footer-updated content p-2 has-text-centered">
            {{ latestUpdateText }}
          </div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import APISTATE from '../../enums/APISTATE';

export default {
  name: 'salaryrate-sidebar',
  data: () => ({
  }),
  computed: {
    ...mapGetters('salaryRateStore', ['rate', 'rateApiState']),
    headerText() {
      if(!this.rate){
        return null;
      }

      if(this.rate.employeeNumber) {        
        return `Lønrater ${this.rate.year} - ${this.rate.employeeNumber}`;
      }

      return `Lønrater ${this.rate.year}`;
    },
    latestUpdateText() {
      return ``;
    },
    loading() {
      return this.rateApiState === APISTATE.LOADING;
    },
    open() {
      return this.rate?.year !== undefined;
    }
  },
  methods: {
    ...mapActions('salaryRateStore', ['cancelEditingRate', 'updateSalaryRate']),
    update() {
    console.log(this.rate);
      this.updateSalaryRate(this.rate);
    },
    cancel() {
      this.cancelEditingRate();
    },
    modelUpdated() {
      this.$nextTick(() => {        
        if(this.rate && this.rate.id) {
          this.$emit('onChange', this.rate);
        }
      });
    },
  },
  watch: {
    'rate'(newValue) {
      this.model = {...newValue};
    }
  }
}
</script>

<style lang="scss" scoped>
.group-comment-sidebar {
  .group-comment-sidebar-contents {
    flex: 1 0 auto;
    border: 3px solid $border;

    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: stretch;

    .sidebar-header {
      flex: 0 1 auto;
      padding: 20px;
    }
    .sidebar-body {
      flex: 1 0 auto;
      padding: 0 10px;
      .is-expanded,
      .textarea {
        height: 100%;
      }
    }
    .sidebar-footer {
      flex: 0 1 auto;
      
      .sidebar-footer-controls {
        padding: 20px;

      }
      .sidebar-footer-updated {
        background-color: $border;
      }
    }
  }
}

.sidebar-field-input > input{
  max-width: 50%;
}
</style>